// agentAutoContinue.js — resume agent runs without making the user type "continue".
// When the loop hits a budget/follow-up wall but the task is not done, SessionWorkspace
// calls runLocalAgentLoop again with an explicit resume prompt.
//
// DeerFlow borrow #1 (docs/DEERFLOW-PADROES-A-ROUBAR.md): a decisão de retomar vem da
// TAXONOMIA de blockers (blockerTaxonomy.classifyBlocker), não de um Set binário — todo
// stopReason é classificado (continue/ask_user/failed/…), então "retomável" cobre também
// output_truncated e done_after_budget-com-verificador-vermelho (goal_not_met_yet).

import { classifyBlocker } from './loop/blockerTaxonomy.js';

export const AUTO_CONTINUE_MAX_ROUNDS = 2; // 3 total runs: initial + 2 auto-resumes

/** Compat: stop reasons SEMPRE retomáveis (a taxonomia é a fonte; este Set é legado). */
export const RESUMABLE_STOP_REASONS = new Set([
  'max_iterations',
  'tools_done_followup_failed',
  'output_truncated',
]);

export function shouldAutoContinue(result, round = 0) {
  if (!result || round >= AUTO_CONTINUE_MAX_ROUNDS) return false;
  return classifyBlocker(result).resumable;
}

/** Model-facing resume instruction for round N (1-based auto round). */
export function buildAutoContinuePrompt(originalTask, round) {
  const task = String(originalTask || '').trim();
  const n = Math.max(1, Number(round) || 1);
  return [
    `[CONTINUAÇÃO AUTOMÁTICA ${n}/${AUTO_CONTINUE_MAX_ROUNDS} — execute com ferramentas, não peça clarificação]`,
    'Retome exatamente de onde parou. Se faltam arquivos para editar, use grep_search/read_file/write_file no worktree.',
    '',
    task || 'Continue a última tarefa incompleta.',
  ].join('\n');
}

/** Short UI status while the next round starts. */
export function autoContinueStatusMessage(round) {
  const n = Math.max(1, Number(round) || 1);
  return {
    role: 'system',
    content: `↻ Continuando automaticamente (rodada ${n + 1}/${AUTO_CONTINUE_MAX_ROUNDS + 1})…`,
  };
}
